import { Component, OnInit } from '@angular/core';
import { FirestoreService } from 'src/app/services/service.index';
import { Router } from '@angular/router';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { Label, Color } from 'ng2-charts';
import Swal from 'sweetalert2';
import * as moment from 'moment';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  user:any;

  public barChartOptions: ChartOptions = {
    responsive: true,
    // We use these empty structures as placeholders for dynamic theming.
    scales: { xAxes: [{}], yAxes: [{}] },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    }
  };
  public barChartLabels: Array<any> =  []; // ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
  public barChartType: ChartType = 'bar'; //horizontalBar
  public barChartLegend:boolean = true;
  //public barChartPlugins = [pluginDataLabels];

  public barChartColors: Color[] = [
    { backgroundColor: '#27ae60' },
    { backgroundColor: '#2980b9' },
    { backgroundColor: '#f39c12' },
    { backgroundColor: '#c0392b' }

  ]

  verGra = false;

  public barChartData: ChartDataSets[] = [
   /* { data: [65, 27, 90, 65, 86, 27, 85,96], label: 'Series A' },
    { data: [28, 48, 40, 19, 86, 27, 90, 65], label: 'Series B' },*/
  ];

 // public barChartData: ChartDataSets[] = [];


  ordersTotal:any = [];
  ordersAsiggned:any = [];
  ordersPending:any = [];
  ordersDelivered:any = [];
  ordersReject:any = [];
  ordersRequestTotal:any = [];

  schedule:any = [];

  constructor(private afs: FirestoreService, private router: Router) {


    //this.barChartLabels = this.schedule;


   }



   ngOnInit() {

    Swal.fire({
      title: 'Loading Data!',
      //html: 'data uploading', // add html attribute if you want or remove
      timer: 5000,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });


    this.user = this.afs.usersShow;

    this.schedule = this.getDaysArrayByMonth();

    let reversed = this.schedule.reverse();

    let today = new Date().getDate();




    let insertPen:any = [];
    let insertAsi:any = [];
    let insertRej:any = [];
    let insertDel:any = [];
    let dataArrayPen:any = [];
    let dataArrayAsig:any = [];
    let dataArrayRej:any = [];
    let dataArrayDel:any = [];

    this.schedule.forEach(async (element) => {




      let day = element.format("DD");

      let numD = day.replace(/^0+/, "");



          if( numD <= today){

           // console.log("HOY ES DD "+today);

           // console.log(" HOY "+numD);

           this.barChartLabels.push(element.format("DD-MMMM"));

           let day =  element.format("DD");
           let month = element.format("MM");
           let year = element.format("YYYY");

            let datesfrom= new Date(year, month-1, day, 0,0,0).getTime();
            let datesto = new Date(year, month-1, day, 23,59,59).getTime();


              dataArrayPen = await this.afs.getAllOrdersByDateGraPending(this.user.companyId, datesfrom, datesto);

              insertPen.push(dataArrayPen.docs.length);

              dataArrayAsig = await this.afs.getAllOrdersByDateGraAssigned(this.user.companyId, datesfrom, datesto);

              insertAsi.push(dataArrayAsig.docs.length);



              dataArrayRej = await this.afs.getAllOrdersByDateGraReject(this.user.companyId, datesfrom, datesto);

              insertRej.push(dataArrayRej.docs.length);

              dataArrayDel = await this.afs.getAllOrdersByDateGraDelivered(this.user.companyId, datesfrom, datesto);

              insertDel.push(dataArrayDel.docs.length);



          }


    });

   // if(  insertAsi.length == today || insertPen.length == today || insertDel.length == today || insertRej.length == today ){

      // || this.schedule.length == insertPen.length ||  this.schedule.length == insertDel.length ||  this.schedule.length == insertRej.length){

       /* console.log(" hoy "+today);
        console.log(insertAsi.length);
        console.log(insertPen.length);
        console.log(insertDel.length);
        console.log(insertRej.length);

        console.log(insertAsi);
        console.log(insertPen);
        console.log(insertDel);
        console.log(insertRej);*/


      this.barChartData.push({ data: insertDel, label: 'Delivered'})
      this.barChartData.push({ data: insertAsi, label: 'Asigned'})
      this.barChartData.push({ data: insertPen, label: 'Pending'})
      this.barChartData.push({ data: insertRej, label: 'Reject'})


      this.verGra = true;


    //}



      if(this.user.companyId == '' || this.user.companyId == undefined){
          console.log("no caompany");
        this.router.navigate(['/company/registercompany']);
      }


      let datestart = new Date(new Date().setHours(0, 0, 0, 0)).getTime();

      this.afs.getAllOrdersGraphics(this.user.companyId, datestart).subscribe(orders => {


        this.ordersTotal = orders.length;

   });


        this.afs.getAllOrdersRequest().subscribe(orders => {


          this.ordersRequestTotal = orders.length;

      });


      this.afs.getAllOrdersByDateStatus(this.user.companyId, datestart, 1).subscribe(orders => {


           this.ordersAsiggned = orders.length;

      });

      this.afs.getAllOrdersByDateStatus(this.user.companyId, datestart, 0).subscribe(orders => {


          this.ordersPending = orders.length;

     });


     this.afs.getAllOrdersByDateStatus(this.user.companyId, datestart, 2).subscribe(orders => {


          this.ordersDelivered = orders.length;

    });

    this.afs.getAllOrdersByDateStatus(this.user.companyId, datestart, 3).subscribe(orders => {


      this.ordersReject= orders.length;

});



  }

   day_of_the_month(d)
  {
    return (d.getDate() < 10 ? '0' : '') + d.getDate();
  }


    // events
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }

  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }

  public randomize(): void {
    // Only Change 3 values
    const data = [
      Math.round(Math.random() * 100),
      59,
      80,
      (Math.random() * 100),
      56,
      (Math.random() * 100),
      40];
    this.barChartData[0].data = data;
  }


  getDaysArrayByMonth() {
    var daysInMonth = moment().daysInMonth();
    var arrDays = [];

    while(daysInMonth) {
      var current = moment().date(daysInMonth);
      arrDays.push(current);
      daysInMonth--;
    }



    return arrDays;
  }

}
